import { Suspense } from 'react'
import { motion } from 'framer-motion'
import PageLoader from './PageLoader'

export default function PageTransition({ children }) {
    return (
        <motion.div
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{
                duration: 0.2,
                ease: 'easeInOut'
            }}
        >
            <Suspense fallback={<PageLoader />}>
                {children}
            </Suspense>
        </motion.div>
    );
}
